import { AuthHeaderMenu } from './AuthHeaderMenu';
import { ProfileMenu } from './ProfileMenu';
import { useGetSignedInUser } from '../../../hooks/useGetSignedInUser';
import { AccountMenuSkeleton } from './AccountMenuSkeleton';
import { useAppSelector } from '../../../store/hooks';
import { GuestUserAccountMenu } from './GuestUserAccountMenu';

export const AccountMenu: React.FC = () => {
  const { isSuccess, isFetching, currentData: userData } = useGetSignedInUser();
  const guestUser = useAppSelector((state) => state.qualification.guestUser);

  if (isFetching) {
    return <AccountMenuSkeleton />;
  }
  if (isSuccess && userData?.user && userData?.token) {
    return (
      <ProfileMenu
        slug={userData.user.slug}
        fullName={userData.user.full_name}
        profilePicture={userData.user.media}
        userId={userData.user.user_id}
      />
    );
  }

  if (guestUser) return <GuestUserAccountMenu guestUser={guestUser} />;

  return <AuthHeaderMenu />;
};
